var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x39_7-docker"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 43.193,
    style: {
      fill: "#099CEC"
    },
    width: 47.506,
    x: 229.999,
    y: 147.225
  }), /*#__PURE__*/React.createElement("rect", {
    height: 42.69,
    style: {
      fill: "#099CEC"
    },
    width: 47.506,
    x: 229.999,
    y: 199.115
  }), /*#__PURE__*/React.createElement("rect", {
    height: 43.193,
    style: {
      fill: "#099CEC"
    },
    width: 47.506,
    x: 173.869,
    y: 147.225
  }), /*#__PURE__*/React.createElement("rect", {
    height: 42.691,
    style: {
      fill: "#099CEC"
    },
    width: 47.507,
    x: 286.2,
    y: 199.043
  }), /*#__PURE__*/React.createElement("rect", {
    height: 43.625,
    style: {
      fill: "#099CEC"
    },
    width: 47.506,
    x: 229.999,
    y: 94.975
  }), /*#__PURE__*/React.createElement("rect", {
    height: 43.193,
    style: {
      fill: "#099CEC"
    },
    width: 47.505,
    x: 117.738,
    y: 147.225
  }), /*#__PURE__*/React.createElement("rect", {
    height: 42.691,
    style: {
      fill: "#099CEC"
    },
    width: 47.506,
    x: 173.869,
    y: 199.043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.441,219.095c-10.35-6.972-34.21-9.487-52.537-6.036     c-2.371-17.249-12.003-32.27-29.538-45.782l-10.062-6.685l-6.685,10.062c-13.225,19.98-16.817,52.896-2.658,74.602     c-6.252,3.377-18.545,7.978-34.786,7.689H27.757c-6.252,36.511,4.169,83.945,31.624,116.501     c26.663,31.551,66.623,47.579,118.872,47.579c113.124,0,196.851-52.104,236.021-146.76c15.381,0.288,48.584,0.073,65.618-32.483     c1.078-1.797,4.743-9.488,6.107-12.291L476.441,219.095z",
    style: {
      fill: "#099CEC"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.186,199.043 109.113,199.043 61.68,199.043 61.68,241.734 109.186,241.734    ",
    style: {
      fill: "#099CEC"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 42.691,
    style: {
      fill: "#099CEC"
    },
    width: 47.505,
    x: 117.738,
    y: 199.043
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/Docker.c1458ec6bc2dfadb44d064525c1d433c.svg";
export { ForwardRef as ReactComponent };